<template>
    <div>
        <div class="container">
            <div class="row mt-3 mb-3">
                <div class="col-sm-12 mb-3">
                    <router-link to="/"><i class="fas fa-chevron-left"></i> Back to home</router-link>
                </div>
                <div class="col-sm-12">
                    <h1 class="h2">My account</h1>
                </div>
            </div>

            <div class="row mb-5">
                <div class="col-sm-8">
                    <!-- panel loop -->
                    <div class="panel panel-toggable mb-3" 
                        v-for="(panel,index) in panels" :key="'panel-' + index"
                        :class="{'panel-is-open': panel.is_open}"
                    >
                        <div class="panel-header" @click="panel.is_open = !panel.is_open ">
                            <div class="font-700">
                                {{panel.title}}
                            </div>
                            <div class="panel-toggle font-400">
                                <span class="icon-right"><i class="fas fa-chevron-right"></i></span>
                                <span class="icon-down"><i class="fas fa-chevron-down"></i></span>
                            </div>
                        </div>
                        <div class="panel-body">
                            <!-- personal information -->
                            <article v-if="panel.name == 'personal_information'">
                                <v-observer mode="lazy" v-slot="{handleSubmit}">
                                    <form
                                        @submit.prevent="handleSubmit(submit_upd_prs_info_form)"
                                    >
                                        <b-form-group label="First name*">
                                            <v-provider rules="required" v-slot="v" name="First name">
                                                <b-form-input 
                                                    v-model="first_name" 
                                                    name="first_name" 
                                                    :state="get_validation_state(v)"
                                                />
                                                <b-form-invalid-feedback :class="{'d-block': v.errors}">
                                                    {{ v.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </v-provider>
                                        </b-form-group>
                                        <b-form-group label="Last name*">
                                            <v-provider rules="required" v-slot="v" name="Last name">
                                                <b-form-input 
                                                    v-model="last_name" 
                                                    :state="get_validation_state(v)"
                                                    name="last_name"
                                                />
                                                <b-form-invalid-feedback :class="{'d-block': v.errors}">
                                                    {{ v.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </v-provider>
                                        </b-form-group>
                                        <b-form-group label="Email*" disabled>
                                            <b-form-input :value="email"/>
                                        </b-form-group>
                                        <b-form-group label="Phone*">
                                            <v-provider rules="required|phone:us" v-slot="v" name="Phone">
                                                <b-form-input 
                                                    v-model="phone" 
                                                    name="phone"
                                                    :state="get_validation_state(v)"
                                                    v-mask="'(###) ###-####'"
                                                />
                                                <b-form-invalid-feedback :class="{'d-block': v.errors}">
                                                    {{ v.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </v-provider>
                                        </b-form-group>
                                        <b-form-group>
                                            <button class="btn btn-primary btn-block">Update my information</button>
                                        </b-form-group>
                                    </form>
                                </v-observer>
                            </article>
                            
                            <!-- change password-->
                            <article v-if="panel.name == 'change_password'">
                                <v-observer mode="lazy" v-slot="{handleSubmit}">
                                    <form
                                        @submit.prevent="handleSubmit(submit_upd_prs_info_form)"
                                    >
                                        <b-form-group label="Password*">
                                            <v-provider rules="required" v-slot="v" name="Password">
                                                <b-form-input 
                                                    type="password"
                                                    v-model="password" 
                                                    name="" 
                                                    :state="get_validation_state(v)"
                                                />
                                                <b-form-invalid-feedback :class="{'d-block': v.errors}">
                                                    {{ v.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </v-provider>
                                        </b-form-group>
                                        <b-form-group label="New password*">
                                            <v-provider rules="required|password:@confirm" v-slot="v" name="New password">
                                                <b-form-input 
                                                    type="password"
                                                    v-model="new_password" 
                                                    :state="get_validation_state(v)"
                                                    name=""
                                                />
                                                <b-form-invalid-feedback :class="{'d-block': v.errors}">
                                                    {{ v.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </v-provider>
                                        </b-form-group>
                                        <b-form-group label="Confirm new password*">
                                            <v-provider rules="required" v-slot="v" vid="confirm" name="Confirm new password">
                                                <b-form-input 
                                                    type="password"
                                                    v-model="confirm_new_password" 
                                                    :state="get_validation_state(v)"
                                                />
                                                <b-form-invalid-feedback :class="{'d-block': v.errors}">
                                                    {{ v.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </v-provider>
                                        </b-form-group>
                                        <b-form-group>
                                            <button class="btn btn-primary btn-block">Update my password</button>
                                        </b-form-group>
                                    </form>
                                </v-observer>
                            </article>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>











<script>
// import {TheMask} from 'vue-the-mask'
// import PrettyCheck from 'pretty-checkbox-vue/check';
// import PrettyRadio from 'pretty-checkbox-vue/radio';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {mask} from 'vue-the-mask';

// Override the default message.
extend('required', {
    ...required,
    message: (_) =>  _ + ' field is required'
});

// phone validation
extend('phone', {
    validate(value, args) {
        const regex = /^\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}$/;
        return args.us == 'us' && value.match(regex); 
    },
    params: ['us'],
    message: 'phone is not valid'
});

//password
extend('password', {
    params: ['target'],
    validate(value, { target }) 
    {
        return value === target;
    },
    message: 'Password confirmation does not match'
});


export default {
    components: {
        // 'the-mask': TheMask,
        // 'p-check': PrettyCheck,
        // 'p-radio': PrettyRadio,
        'v-provider': ValidationProvider,
        'v-observer': ValidationObserver,
    },

    directives: {
        mask
    },

    props: {

    },

    data() {
        return {
            panels: [
                {
                    name: 'personal_information',
                    title: 'Personal information',
                    is_open: true
                },
                {
                    name: 'change_password',
                    title: 'Change password',
                    is_open: false
                },
                {
                    name: 'delivery_information',
                    title: 'Delivery information',
                    is_open: false
                },
                {
                    name: 'payment_option',
                    title: 'Payment options',
                    is_open: false
                },
            ],
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            password: '',
            new_password: '',
            confirm_new_password: '',
        };
    },

    computed: {

    },

    mounted() {
        //
    },

    methods: {
        /**
         * 
         * 
         */
        submit_upd_prs_info_form()
        {
            console.log('form submitted');
        },

        /**
         * 
         */
        get_validation_state({dirty, validated, valid = null})
        {
            return dirty || validated ? valid : null;
        }
    }
}
</script>

<style lang="scss" scoped>

</style>